import { SessionSummaryResponse } from '@fullstory/proto/fs/services/llm-tool';

export const mockSessionSummaryResponse = ({
  summary = 'Test session summary',
}: Partial<SessionSummaryResponse>): SessionSummaryResponse => ({
  summary,
});

export const mockSessionSummaryStreamResponse = ({
  summary = 'Test session summary',
}: Partial<SessionSummaryResponse>): SessionSummaryResponse => ({
  summary,
});
